import { useMemo } from 'react';
import { usePermissions } from '@/hooks/usePermissions';
import { useLayoutPreferences } from '@/contexts/LayoutPreferencesContext';
import { buildMenu } from '@/data/menu';
import { resolveMenuOrder } from '@/lib/menuNavigation';

export function useNavigationMenu() {
  const { isAdmin, isPerfilBloqueado, temAcessoModulo } = usePermissions();
  const { preferences } = useLayoutPreferences();
  return useMemo(
    () => resolveMenuOrder(buildMenu(!isPerfilBloqueado, temAcessoModulo, isAdmin), preferences.menuOrder),
    [isPerfilBloqueado, temAcessoModulo, isAdmin, preferences.menuOrder],
  );
}
